'use client';
import { createContext, useContext } from 'react';
import type { RunnerInterfaceStoreSelectors } from './runner/selectors';
import type { BuilderInterfaceStoreSelectors } from './builder/selectors';

export const InterfaceStoreContext = createContext<
  RunnerInterfaceStoreSelectors | BuilderInterfaceStoreSelectors | null
>(null);

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- required to differentiate between runner and builder
export const useInterfaceStore = <T = RunnerInterfaceStoreSelectors>(): T => {
  const _useStore = useContext(InterfaceStoreContext);
  if (!_useStore) {
    throw new Error('Missing InterfaceStoreContext.Provider');
  }
  return _useStore as T;
};
